import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const AdjustIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <circle cx="18.5" cy="7.5" r="2.5" fill={getColor(secondaryColor)} />
      <circle cx="5.5" cy="16.5" r="2.5" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8961 8.35002C21.5163 9.87225 20.1398 11 18.5 11C16.8602 11 15.4837 9.87225 15.1039 8.35002H0V6.65002H15.1039C15.4837 5.12777 16.8601 4 18.5 4C20.1399 4 21.5163 5.12777 21.8961 6.65002L24 6.65002V8.35002L21.8961 8.35002ZM18.5 9.3C19.4941 9.3 20.3 8.49411 20.3 7.5C20.3 6.50589 19.4941 5.7 18.5 5.7C17.5059 5.7 16.7 6.50589 16.7 7.5C16.7 8.49411 17.5059 9.3 18.5 9.3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.89606 17.35C8.51628 18.8723 7.13984 20 5.5 20C3.86016 20 2.48372 18.8723 2.10394 17.35L0 17.35V15.65L2.10392 15.65C2.48369 14.1278 3.86014 13 5.5 13C7.13986 13 8.51631 14.1278 8.89608 15.65H24V17.35H8.89606ZM5.5 18.3C6.49411 18.3 7.3 17.4941 7.3 16.5C7.3 15.5059 6.49411 14.7 5.5 14.7C4.50589 14.7 3.7 15.5059 3.7 16.5C3.7 17.4941 4.50589 18.3 5.5 18.3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default AdjustIconFilled;
